module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/checkbox-2017405a29de6cb2ed507c7ccda1d04b.png";